(()=>{
 const bar=document.querySelector('[data-nx4-sticky]');const root=document.querySelector('[data-nx4]');
 if(!bar||!root||bar.dataset.mounted)return;bar.dataset.mounted='true';
 const original=root.querySelector('[data-nx4-atc]'), buy=bar.querySelector('[data-sticky-buy]');
 const summary=bar.querySelector('.nx4__sticky-summary');let scheduled=false;
 function sync(){
  scheduled=false;
  const mode=root.querySelector('[name="nx4-mode"]:checked')?.value;
  const pack=root.querySelector('[data-nx4-packs] input:checked')?.closest('label')?.querySelector('.nx4__pack-name')?.textContent;
  const flavor=root.querySelector('[data-nx4-flavors] input:checked')?.value || '';
  const checked=root.querySelector('[data-nx4-packs] input:checked');
  bar.querySelector('[data-sticky-selection]').textContent=`${flavor} · ${pack || (checked?.value ? checked.value+' tins':'Nurox')}`;
  const price=root.querySelector(mode==='sub'?'[data-nx4-sub-price]':'[data-nx4-once-price]')?.textContent || '';
  bar.querySelector('[data-sticky-price]').textContent=`${price} · ${mode==='sub'?'Subscription':'One time'}`;
  buy.textContent=(original.querySelector('[data-nx4-atc-text]')||original).textContent.trim();buy.disabled=original.disabled;
  bar.hidden=innerWidth>=768 || original.getBoundingClientRect().bottom>=0 || !!document.querySelector('dialog[open]');
 }
 function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(sync);}}
 buy.addEventListener('click',()=>{if(!original.disabled)original.click();});
 summary.addEventListener('click',()=>root.querySelector('[data-nx4-form]').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'}));
 addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);
 new MutationObserver(schedule).observe(root,{childList:true,subtree:true,attributes:true,characterData:true});
 document.querySelectorAll('dialog').forEach(el=>new MutationObserver(schedule).observe(el,{attributes:true,attributeFilter:['open']}));
 root.addEventListener('change',schedule);sync();
})();
